import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const TutorShiftApiUtils = {
  fetch(startTime) {
    let query = '?startTime=' + startTime;
    return xhr(ApiConstants.Base + 'shifts' + query);
  },
};

export default TutorShiftApiUtils;
